import BaseApi from './baseApi';
import IListCurrency from '../models/IListCurrency';
import IAuthentication from '../models/IAuthentication';
export default class ListCurrencyApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListCurrencies() : Promise<IListCurrency[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listCurrency: IListCurrency[] = [];
            listCurrency = response.data as IListCurrency[];
            return listCurrency;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListCurrency(listCurrency: IListCurrency) : Promise<string> {
        const json = this.getJsonSave(listCurrency);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListCurrency(listCurrency: IListCurrency) : Promise<boolean> {
        const json = this.getJsonUpdate(listCurrency);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListCurrency(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_CURRENCY_IN_USE",
            "parameters": [{
                "Item1": "CurrencyId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListCurrencies",
                "Item2": "id"
            }, {
                "Item1": "ListCurrencies",
                "Item2": "name"
            }, {
                "Item1": "ListCurrencies",
                "Item2": "symbol"
            }, {
                "Item1": "ListCurrencies",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "ListCurrencies"
            }],
            "conditions": [{
                "Item1": "ListCurrencies",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListCurrencies",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListCurrencies.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListCurrencies",
            "conditions": [{
                "Item1": "ListCurrencies",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listCurrency: IListCurrency) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listCurrency.name
            }, {
                "Item1": "symbol",
                "Item2": listCurrency.symbol
            }, {
                "Item1": "idCompany",
                "Item2": listCurrency.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListCurrencies"
        };
        return json;
    }

    private getJsonUpdate(listCurrency: IListCurrency) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listCurrency.name
            }, {
                "Item1": "symbol",
                "Item2": listCurrency.symbol
            }, {
                "Item1": "idCompany",
                "Item2": listCurrency.idCompany
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListCurrencies",
            "keyvalue": listCurrency.id
        };
        return json;
    }
}
